import React, {FC} from 'react'

import cn from 'classnames/bind'
import DatePicker, {DatePickerProps} from 'react-date-picker/dist/entry.nostyle'

import s from './InputDate.module.scss'
import 'node_modules/react-calendar/dist/Calendar.css'
import 'node_modules/react-date-picker/dist/DatePicker.css'
import ErrorMessage from '../ErrorMessage'
import FieldLabel from '../FieldLabel'
import {IFieldBase} from '../Input/Input'
const cx = cn.bind(s)

interface IInputDateProps extends IFieldBase, DatePickerProps {
	className?: string
	wrapperClassName?: string
	variant?: 'default' | 'editable' | 'new'
	size?: 'medium' | 'large'
	labelAs?: 'label' | 'div'
	labelClassName?: string
}

const InputDate: FC<IInputDateProps> = ({
	wrapperClassName,
	label,
	error,
	isError,
	labelAs = 'label',
	variant = 'default',
	size = 'medium',
	labelClassName,
	...props
}) => {
	return (
		<div
			className={cx('wrapper', wrapperClassName, variant, size, {
				isError: isError || error,
			})}>
			<div className={cx('inner')}>
				{label ? (
					<FieldLabel
						as={labelAs}
						label={label}
						className={labelClassName}
						required={props.required}>
						<DatePicker
							locale="EN-us"
							format="MMMM dd, yyyy"
							{...props}
							className={cx('input', props.className)}
						/>
					</FieldLabel>
				) : (
					<DatePicker
						locale="EN-us"
						format="MMMM dd, yyyy"
						{...props}
						className={cx('input', props.className)}
					/>
				)}
			</div>
			<ErrorMessage error={error} />
		</div>
	)
}

InputDate.displayName = 'InputDate'

export default InputDate
